import {SectionIntro, Section} from '@primer/react-brand'
import type {FeaturedContentProps} from './types'
import {renderWithNoMarks} from '../../../utils'
import {FlexSuiteRiverAccordion} from '../../../components/FlexSuiteRiverAccordion'
import {FlexSuiteRiverStack} from '../../../components/FlexSuiteRiverStack'

const FeaturedContent = ({
  featureHeading,
  featureLabel,
  featureDescription,
  featureLink,
  featureDetailsOne,
  featureRiverAccordion,
  featureRiverStack,
}: FeaturedContentProps) => {
  return (
    <Section>
      <SectionIntro align="center">
        {featureLabel && <SectionIntro.Label>{featureLabel}</SectionIntro.Label>}
        {featureHeading && <SectionIntro.Heading>{renderWithNoMarks(featureHeading)}</SectionIntro.Heading>}
        {featureDescription && (
          <SectionIntro.Description>{renderWithNoMarks(featureDescription)}</SectionIntro.Description>
        )}
        {featureLink && <SectionIntro.Link href={featureLink.fields.href}>{featureLink.fields.text}</SectionIntro.Link>}
      </SectionIntro>
      {featureDetailsOne === 'Accordion' && featureRiverAccordion && (
        <FlexSuiteRiverAccordion items={featureRiverAccordion} />
      )}
      {featureDetailsOne === 'Stack' && featureRiverStack && <FlexSuiteRiverStack items={featureRiverStack} />}
    </Section>
  )
}
export {FeaturedContent}
